import { readAuthSession } from '@/services/auth';

export const PUBLIC_ROUTE_NAMES = Object.freeze([
  'Maintenance',
  'LoginForm',
  'RegisterForm',
  'EmailVerification',
]);

export const isPublicRoute = (to) => PUBLIC_ROUTE_NAMES.includes(to.name);

export const getAuthContext = () => {
  const session = readAuthSession();

  return {
    isAuthenticated: !!session.accessToken,
    isAdmin: session.isAdmin,
  };
};

export const authGuard = (to, authContext = getAuthContext()) => {
  if (to.meta.requiresAuth && !authContext.isAuthenticated) {
    localStorage.setItem('intendedRoute', to.fullPath);

    return {
      name: 'LoginForm',
      query: { redirect: to.fullPath },
    };
  }

  return null;
};
